import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { colors } from '../../constants/theme';
import MatchCard from '../Common/MatchCard';
import { matchesService } from '../../services/api';

const MatchManager = ({ matches, onUpdateScore, onFinishMatch, onMatchesUpdate }) => {
  const [loading, setLoading] = useState(false);

  // ✅ NOVO: Método para finalizar partida com atualização automática
  const handleFinishMatch = async (matchId) => {
    setLoading(true);
    try {
      console.log(`🏁 Finalizando partida ${matchId}...`);
      
      const response = await matchesService.finishMatch(matchId);

      if (response.success) {
        const { player1, player2, finalScore, winnerName, isDrawn } = response.data;
        const resultLine = isDrawn
          ? 'Resultado: Empate'
          : `Vencedor: ${winnerName || 'desconhecido'}`;
        alert(
          `✅ Partida finalizada!\n${resultLine}\nPlacar: ${player1.name} ${finalScore.player1} x ${finalScore.player2} ${player2.name}`,
        );

        if (onMatchesUpdate) {
          await onMatchesUpdate();
        }

        if (response.data.advance) {
          console.log('🔄 Avanço de fase disparado:', response.data.advance);
        }
      } else {
        throw new Error(response.error?.message || 'Erro ao finalizar partida');
      }
    } catch (error) {
      console.error('❌ Erro ao finalizar partida:', error);
      alert(`❌ Erro ao finalizar partida:\n${error.error?.message || error.message || 'Erro desconhecido'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold" style={{ color: colors.primary }}>
          Partidas em Andamento
        </h2>
        {loading && (
          <div className="flex items-center space-x-2 text-blue-600">
            <RefreshCw className="h-4 w-4 animate-spin" />
            <span>Processando...</span>
          </div>
        )}
      </div>
      
      <div className="grid md:grid-cols-2 gap-6">
        {matches.map((match) => (
          <MatchCard
            key={match.id}
            match={match}
            isOrganizer={true}
            onUpdateScore={onUpdateScore}
            onFinishMatch={handleFinishMatch} // ✅ Usar método atualizado
            disabled={loading}
          />
        ))}
      </div>
    </div>
  );
};

export default MatchManager;